import React from 'react';
import PropTypes from 'prop-types';

class FreeToAnnual extends React.Component {
    render() {
        return (
            <div className="promo-content">
                {this.props.image ? (
                    this.props.image
                ) : null}
                <div className="main-copy">
                    {`One year of Pro for just $${this.props.promo.price}`}
                </div>
                <div className="sub-copy">
                    Lock in our best available price our most popular plan. Limited time offer.
                </div>
                <div className="promo-action-button" role="button" aria-label="Claim the deal"  onClick={(e) => {
                    if (this.props.isFreeUser()) {
                        this.props.router.navigate(`/account/subscription/new?code=${this.props.promo.couponCode}&plan=6&term=2`);
                    } else {
                        this.props.onRedeemPromoClick(e);
                    }
                }}>
                    {'Get our best price'}
                </div>
                <div className="last-chance">
                    {`Get 12 months of our powerful Pro plan for just $${this.props.promo.price} today`}
                </div>
                <div className="coming-soon">
                    <h3>Set It and Forget It with our Pro Features</h3>
                    <div className="feature-list">
                        {this.props.features.map((feature, i) => {
                            return (
                                <div key={`feature-${i}`} className="feature-detail">
                                    <div className="feature-image">
                                        <img src={feature.image}/>
                                    </div>
                                    <div className="feature-name">
                                        {feature.label}
                                    </div>
                                    <div className="feature-desc">
                                        {feature.description}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        )
    }
}

FreeToAnnual.displayName = "FreeToAnnual";

FreeToAnnual.propTypes = {
    image: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.object
    ]),
    promo: PropTypes.object,
    onRedeemPromoClick: PropTypes.func,
    features: PropTypes.array,
    planAddOns: PropTypes.number
};

FreeToAnnual.defaultProps = {
    image: null,
    promo: null,
    onRedeemPromoClick: () => {},
    features: [],
    planAddOns: 0
};

export default FreeToAnnual;